// /src/pages/publicTab/Allies.jsx

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import DiscordLogo from '../../medias/discord.png';
import GuildedLogo from '../../medias/guilded.png';
import RsiLogo from '../../medias/rsi.png';
import WebsiteLogo from '../../medias/website.png';

function Allies() {
  const [allies, setAllies] = useState([]);

  useEffect(() => {
    const fetchAllies = async () => {
      try {
        const response = await axios.get('/api/admin/get-allies-all-info');
        if (response.data && response.data.allies) {
          const sorted = response.data.allies.sort(
            (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
          );
          setAllies(sorted);
        }
      } catch (error) {
        console.error('Failed to fetch allies information:', error);
      }
    };

    fetchAllies();
  }, []);

  const injectStyles = (documentName, cssPublic, hash) => {
    const STYLE_ID = `style-${documentName}`;
    let styleEl = document.getElementById(STYLE_ID);
    const prevHash = styleEl?.getAttribute('data-hash') || null;

    if (!styleEl) {
      styleEl = document.createElement('style');
      styleEl.id = STYLE_ID;

      const meta = document.querySelector('meta[name="csp-nonce"]');
      const nonce = meta && meta.content;
      if (nonce) styleEl.setAttribute('nonce', nonce);

      document.head.appendChild(styleEl);
    }

    if (hash && hash !== prevHash) {
      styleEl.textContent = cssPublic || '';
      styleEl.setAttribute('data-hash', hash);
    }
  };

  const handleIconMouseEnter = (event) => {
    event.target.style.objectPosition = 'bottom';
  };

  const handleIconMouseLeave = (event) => {
    event.target.style.objectPosition = 'top';
  };

  return (
    <div className="allies-container">
      {allies.map((ally) => {
        const documentName = `allie-${ally.orgName}`;
        if (ally.cssPublic) injectStyles(documentName, ally.cssPublic, ally.contentHash);

        const trustedHTML = (() => {
          if (window.trustedTypes) {
            try {
              const policy = window.trustedTypes.createPolicy('pallasPages', {
                createHTML: (input) => input,
                createScript: (input) => input,
                createScriptURL: (input) => input,
              });
              return policy.createHTML(ally.orgDescription);
            } catch {
              return window.trustedTypes.createPolicy('pallasPages').createHTML(ally.orgDescription);
            }
          }
          return ally.orgDescription;
        })();

        return (
          <div key={ally.id} className="ally-item">
            <div className="ally-content">
              <div className="ally-logo">
                <img src={ally.orgLogo} alt={`${ally.orgName} Logo`} />
              </div>
              <div className="ally-details">
                <h3>{ally.orgName}</h3>
              </div>
            </div>

            <div className="ally-description-icons">
              <div
                className="ally-description lexical-rendered-content"
                data-doc={documentName}
                role="document"
                dangerouslySetInnerHTML={{ __html: trustedHTML }}
              />

              <div className="ally-icons">
                {ally.rsiLink && (
                  <a href={ally.rsiLink} target="_blank" rel="noopener noreferrer">
                    <img
                      src={RsiLogo}
                      alt="RSI"
                      className="ally-icon rsi-icon"
                      onMouseEnter={handleIconMouseEnter}
                      onMouseLeave={handleIconMouseLeave}
                    />
                  </a>
                )}
                {ally.discordLink && (
                  <a href={ally.discordLink} target="_blank" rel="noopener noreferrer">
                    <img
                      src={DiscordLogo}
                      alt="Discord"
                      className="ally-icon discord-icon"
                      onMouseEnter={handleIconMouseEnter}
                      onMouseLeave={handleIconMouseLeave}
                    />
                  </a>
                )}
                {ally.guildedLink && (
                  <a href={ally.guildedLink} target="_blank" rel="noopener noreferrer">
                    <img
                      src={GuildedLogo}
                      alt="Guilded"
                      className="ally-icon guilded-icon"
                      onMouseEnter={handleIconMouseEnter}
                      onMouseLeave={handleIconMouseLeave}
                    />
                  </a>
                )}
                {ally.websiteLink && (
                  <a href={ally.websiteLink} target="_blank" rel="noopener noreferrer">
                    <img
                      src={WebsiteLogo}
                      alt="Website"
                      className="ally-icon website-icon"
                      onMouseEnter={handleIconMouseEnter}
                      onMouseLeave={handleIconMouseLeave}
                    />
                  </a>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default Allies;
